
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"58","height":"58","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.223 5.462l15.732 8.482c1.837.991 1.837 3.819 0 4.81l-15.732 8.482a4.68 4.68 0 01-4.447 0l-15.732-8.483c-1.837-.99-1.837-3.818 0-4.809l15.732-8.482a4.68 4.68 0 014.447 0zM8.725 24.48l14.62 7.323a5.41 5.41 0 012.973 4.81v13.823c0 2.006-2.102 3.286-3.89 2.392L7.805 45.506a5.41 5.41 0 01-2.972-4.81V26.874c0-2.006 2.102-3.286 3.89-2.392zM49.275 24.48l-14.62 7.323a5.41 5.41 0 00-2.973 4.81v13.823c0 2.006 2.102 3.286 3.89 2.392l14.621-7.322a5.41 5.41 0 002.973-4.81V26.874c0-2.006-2.103-3.286-3.891-2.392z","stroke":"#989898","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    